import { tpTheme, TpLogo } from "@trainingpeaks/designtokens";

interface SubscriptionLogoProps {
  logoType: "tp" | "coach" | "custom";
  logoUrl?: string;
}

const SubscriptionLogo = ({ logoType, logoUrl }: SubscriptionLogoProps) => {
  const bgcolor =
    logoType === "tp"
      ? tpTheme.semanticLayer.colors.primary.main
      : tpTheme.semanticLayer.colors.primary.dark;

  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={`${logoType} logo`}
        className="w-9 h-9 rounded-full object-cover flex-shrink-0"
      />
    );
  }

  return (
    <div
      className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0"
      style={{ backgroundColor: bgcolor }}
    >
      <TpLogo size="20" fill="white" />
    </div>
  );
};

export default SubscriptionLogo;
